module.exports = __webpack_public_path__ + "static/TiemposFineWeb-Semibold-2b8031ea464cdf4d4c0c0ef279f78df6.woff2";